import { Selector } from '@ngxs/store';
import { AppStateModel } from '@store/models/app.model';
import { AppState } from '@store/states/app.state';

export class AppSelectors {
  @Selector([AppState])
  static userInfo(state: AppStateModel) {
    return state?.userInfo;
  }
}
